import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("form-alert__span-0ow9nc", {
  display: "block",
  color: "var(--system-error)",
  paddingTop: "6px",
  fontSize: "16px",
  fontWeight: "600",
  "@media (max-width: 767px)": {
    fontSize: "14px"
  }
});
import React from 'react';

/**
 * Simple Accessible Alert component that can be re-used.
 * @alias HtmlPropsHTMLSpanElement>
 * */
const FormAlert = React.forwardRef<HTMLSpanElement, HtmlProps<HTMLSpanElement>>((props, ref) => <span {..._mergeProps({
  ref: ref,
  role: "alert",
  css: _staticStyles
}, props)} />);
FormAlert.displayName = 'FormAlert';
export default FormAlert;